/**
 * Editor type for template and artefact content editing.
 * Determines which editor component is loaded for content editing.
 */
export enum TeEditorTypeEnum {

    /**
     * TinyMCE WYSIWYG visual editor
     */
    WYSIWYG,

    /**
     * CodeMirror raw code editor for HTML/FreeMarker
     */
    CODE,

    /**
     * Block-based editor (future feature, currently disabled)
     */
    BLOCK,

}
